import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.4281 20.0278C13.1688 20.287 12.8545 20.4168 12.4853 20.4171C12.116 20.4168 11.8017 20.287 11.5425 20.0278L4.94281 13.4281C4.68354 13.1688 4.55374 12.8546 4.55343 12.4853C4.55374 12.116 4.68354 11.8018 4.94281 11.5425L11.5425 4.94282C11.8017 4.68355 12.116 4.55375 12.4853 4.55344C12.8545 4.55375 13.1688 4.68355 13.4281 4.94282L20.0278 11.5425C20.287 11.8018 20.4168 12.116 20.4171 12.4853C20.4168 12.8546 20.287 13.1688 20.0278 13.4281L13.4281 20.0278ZM12.4853 19.085L19.0849 12.4853L12.4853 5.88563L5.88562 12.4853L12.4853 19.085ZM12.4853 19.085L5.88562 12.4853L12.4853 19.085Z",
      fill: "black"
    }, null, -1)
  ]))]))
}
export default { render: render }